//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.PrevzateDokSpisListPage.ts           </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class PrevzateDokSpisListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GPredanoFilterDto;

        onContentReady() {
            var that = this;
            PodDokSpisListBasePage.InitList(this);
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            this.model.TypPredani = Wfl.Interface.TypPredani.Cilene;

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dsred" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky",
                    hardDefaultFilter: this.model,
                    autoLoadAfterCreatePanel: this.NacistSeznamPriOtevreni
                })

            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            //this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateFilterForms()
        {
            var that = this;
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků
            filterForm.addPrefab(Gordic.Gin.Prefabs.GSuFunRef(
                {
                    name: "Predavajici",
                    model: "model.Prevzal.ixs_su=value.ixs_su;model.Prevzal.ixs_fun=value.ixs_fun",
                    serverFilters: {
                        aktivita: [100],
                    },
                    change: function (ev, data) {
                        //that.SuFunRefChange(data.value);
                    }
                },
                // 26.03.2020 - TFeik
                // Doplněn příznak zda se funkce používá v redistribuci / předání.
                undefined,
                {
                    modPredani: false
                }));

            filterForm.addRow({ label: "" }).addField("gradio", {
                name: "TypPredani", itemClass: "",
                initialValue: Wfl.Interface.TypPredani.Cilene,
                radios: [
                    { value: Wfl.Interface.TypPredani.Fyzicky, label: 'jres:23900128' }, //RC 23900128 : Převzato fyzicky
                    { value: Wfl.Interface.TypPredani.Cilene, label: 'jres:23900129' }, //RC 23900129 : Převzato cíleně
                ],
                //change: function (event, input)
                //{
                //    that.model.TypPredani = input.value
                //}
            })

            filterForm.addRow({ layoutDescriptor: "w-6" }).addField("gdatecombobox", {
                name: "DatumField",
                model: "model.Datum=value.date",
                defaultInitialValue: "all",
                daysRangeMax: this.DaysRangeMax,
                contextMenu: {
                    daysRange: 50
                },
                userSettings: this.userSettings,
            });
            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GSeznamFilterBaseDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            //nacteni dat do gridu
            this.model = $.extend({}, this.model, filtr);
            this.call<Wfl.Interface.SeznamPrevzateDto[]>("LoadData", { "model": this.model })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view);
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that); });
        }

        ReloadData() {
            this.LoadData(this.model);
        }
    }
};
